export default class PassUtils {
    static toInputId(type:"name"|"val",passwordId:string,index:number) {
        return `${type}_${passwordId}_${index+1}`
    }
    static fromInputId(id:string) {
        const [type,passwordId,index] = id.split("_")
        return {type:type as "name"|"val",passwordId,index:parseInt(index)}
    }
}